import { Container, List, ListItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import BazarImage from "components/BazarImage";
import CategorySectionHeader from "components/CategorySectionHeader";
import { FlexBox, FlexRow } from "components/flex-box";
import ShopLayout1 from "components/layouts/ShopLayout1";
import Navbar from "components/navbar/Navbar";
import { Paragraph, Span } from "components/Typography";
import React from "react";

const useStyles = makeStyles(() => ({
  boldUnderline: {
    fontWeight: "bold",
    textDecoration: "underline",
  },
}));

const TermsAndConditions = () => {
  const classes = useStyles();

  return (
    <ShopLayout1 title="Terms & Conditions" navbar={<Navbar />}>
      <Container maxWidth="lg" sx={{ p: 2, mb: 15 }}>
        <CategorySectionHeader title="Terms & Conditions" />
        <BazarImage
          alt="contact-us"
          src={"/assets/images/banners/terms-and-conditions.png"}
          sx={{ width: "100%", mt: 2 }}
        />
        <FlexRow mt={5}>
          <Paragraph>1.</Paragraph>
          <Paragraph ml={1}>
            A warranty slip is required for the return, exchange, or repair of
            any defective product purchased from PC Worth. If the warranty slip
            is lost, the end user can present the product&apos;s box, if the
            serial number and barcode sticker are intact and readable.
            Registered users can also provide the product warranty record from
            the Product Warranty menu on their account dashboard.
          </Paragraph>
        </FlexRow>
        <FlexRow mt={1}>
          <Paragraph>2.</Paragraph>
          <Paragraph ml={1}>
            Items claimed to have a factory defect will be sent to Technical
            Support for evaluation, which may take some time. A product is
            eligible for replacement if returned to PC Worth within thirty days
            (30) days of purchase, in good condition, with all accessories,
            manuals, and packaging intact, and confirmed defective by Technical
            Support.{" "}
            <Span className={classes.boldUnderline}>
              PRODUCTS RETURNED AFTER THIRTY DAYS OR WITH PHYSICAL DAMAGE ARE
              NOT COVERED BY THIS POLICY
            </Span>{" "}
            and must go to the product service center for assistance.
          </Paragraph>
        </FlexRow>
        <FlexBox flexDirection="column" paddingTop={2}>
          <FlexRow mt={1}>
            3.&nbsp;<strong>GUIDELINES UPON CLAIMING WARRANTY: </strong>
          </FlexRow>
          <FlexBox ml={6}>
            <ul style={{ listStyleType: "disc" }}>
              <li>
                The Warranty Slip issued by PC WORTH must be presented with the
                concerned item with the correct serial number and the warranty
                sticker is intact. Failure to comply{" "}
                <Span className={classes.boldUnderline}>
                  NO WARRANTY SLIP MEANS NO WARRANTY
                </Span>
                .
              </li>
              <li>
                During the warranty period, PC Worth provides free warranty
                repairs at our shop.{" "}
                <Span className={classes.boldUnderline}>
                  THIS DOES NOT COVER ANY SOFTWARE-RELATED ISSUES. IF YOUR
                  STORAGE DEVICE IS DEFECTIVE, PC WORTH IS NOT LIABLE FOR ANY
                  LOSS OF DATA OR FILES. WE STRONGLY ADVISE BACKING UP ALL
                  IMPORTANT FILES BEFORE BRINGING YOUR UNIT IN FOR REPAIR.
                </Span>
              </li>
              <li>
                <strong>NO RETURN POLICY</strong> unless the product is
                defective.
              </li>
              <li>
                <strong>NO CASH REFUNDS</strong>
              </li>
            </ul>
          </FlexBox>
        </FlexBox>
        <FlexRow mt={1}>
          <Paragraph>4.</Paragraph>
          <Paragraph ml={1}>
            <Span className={classes.boldUnderline}>WARRANTY PERIOD:</Span>
            The warranty period for all products begins upon the purchase date
            and is indicated on the warranty slip and recorded on the PC Worth
            eCommerce Product Warranty menu, accessible only to registered
            users.
          </Paragraph>
        </FlexRow>
        <FlexBox mt={1} sx={{ flexDirection: "column" }}>
          <FlexRow>
            <Paragraph>5.</Paragraph>
            <Paragraph sx={{ fontWeight: "bold", ml: 1 }}>
              MONITOR AND LAPTOP WARRANTY:
            </Paragraph>
          </FlexRow>
          <List sx={{ pl: 4, py: 0.1 }}>
            <ListItem sx={{ flexDirection: "column", alignItems: "start" }}>
              <Paragraph sx={{ fontWeight: "bold" }}>Monitor:</Paragraph>
              <ul style={{ listStyleType: "disc", paddingLeft: "2em" }}>
                <li>
                  LCD/LED monitors with 1-5 dead pixels are considered
                  functional.
                </li>
                <li>
                  Monitors with 6 or more dead pixels are eligible for warranty
                  claims.
                </li>
                <li>
                  Monitors under warranty must be returned with the original
                  box, all accessories, stand, and Styrofoam.
                </li>
              </ul>
            </ListItem>
            <ListItem sx={{ flexDirection: "column", alignItems: "start" }}>
              <Paragraph sx={{ fontWeight: "bold" }}>
                Laptop Warranty:
              </Paragraph>
              <ul style={{ listStyleType: "disc", paddingLeft: "2em" }}>
                <li>
                  Covers defects in hardware components, including the
                  processor, memory (RAM), storage (SSD/HDD), display, and power
                  adapter.
                </li>
                <li>
                  <Span sx={{ fontWeight: "bold" }}>Exclusions: </Span>
                  The warranty does not cover physical damage, liquid spills, or{" "}
                  <Span className={classes.boldUnderline}>
                    SOFTWARE-RELATED ISSUES
                  </Span>
                  . Damage from misuse or unauthorized modifications will void
                  the warranty.
                </li>
                <li>
                  <Span sx={{ fontWeight: "bold" }}>Service and Support: </Span>
                  Warranty repairs can be performed at any authorized service
                  center. Ensure the original box, accessories, Styrofoam,
                  receipt, and warranty slip are presented when making a claim.
                </li>
              </ul>
            </ListItem>
          </List>
        </FlexBox>
        <FlexRow mt={1}>
          <Paragraph>6.</Paragraph>
          <Paragraph className={classes.boldUnderline} ml={1}>
            NO WARRANTY ON SOFTWARE, CONSUMABLES, OR FREEBIES
          </Paragraph>
        </FlexRow>
        <FlexRow mt={1}>
          <Paragraph>7.</Paragraph>
          <Paragraph ml={1}>
            Within the warranty period, all defective items are subject to
            inspection and repair only. The decision and duration for
            replacement depend on the distributor or manufacturer of the
            defective item(s).
          </Paragraph>
        </FlexRow>
        <FlexRow mt={1}>
          <Paragraph>8.</Paragraph>
          <Paragraph ml={1} className={classes.boldUnderline}>
            THE WARRANTY DOES NOT COVER THE FOLLOWING:
          </Paragraph>
        </FlexRow>
        <FlexRow>
          <Paragraph ml={3}>{"a)"}</Paragraph>
          <Paragraph ml={1} className={classes.boldUnderline}>
            No box means no warranty. items must be complete in package (box,
            accessories, and manual) for warranty.
          </Paragraph>
        </FlexRow>
        <FlexRow>
          <Paragraph ml={3}>{"b)"}</Paragraph>
          <Paragraph ml={1}>
            If the warranty sticker is tampered or missing.
          </Paragraph>
        </FlexRow>
        <FlexRow>
          <Paragraph ml={3}>{"c)"}</Paragraph>
          <Paragraph ml={1}>If the warranty slip is not presented.</Paragraph>
        </FlexRow>
        <FlexRow>
          <Paragraph ml={3}>{"d)"}</Paragraph>
          <Paragraph ml={1}>
            The product serial number has been altered, defaced or removed.
          </Paragraph>
        </FlexRow>
        <FlexRow>
          <Paragraph ml={3}>{"e)"}</Paragraph>
          <Paragraph ml={1}>Free or promo items given away.</Paragraph>
        </FlexRow>
        <FlexRow>
          <Paragraph ml={3}>{"f)"}</Paragraph>
          <Paragraph ml={1}>
            Compatibility is customer’s responsibility. pc WORTH is not liable
            in any customer’s decision.
          </Paragraph>
        </FlexRow>
        <FlexRow>
          <Paragraph ml={3}>{"g)"}</Paragraph>
          <Paragraph ml={1} className={classes.boldUnderline}>
            Software issues such as defects/ malfunction caused by viruses and
            software incompatibility.
          </Paragraph>
        </FlexRow>
        <FlexRow>
          <Paragraph ml={3}>{"h)"}</Paragraph>
          <Paragraph ml={1} className={classes.boldUnderline}>
            Damage including bent pins, blown metal burns, cracks, corner, rust,
            corrosion, molten wires, circuit board cut braces, scratches, dents,
            moist, pest infection, natural disaster
          </Paragraph>
        </FlexRow>
        <FlexRow>
          <Paragraph ml={3}>{"i)"}</Paragraph>
          <Paragraph ml={1} className={classes.boldUnderline}>
            Damage caused by the customer due to accident, transport, delivery,
            misuse, mishandling, negligence, abuse, incidents, use of product in
            voltages other than designated.
          </Paragraph>
        </FlexRow>
        <FlexRow>
          <Paragraph ml={3}>{"j)"}</Paragraph>
          <Paragraph ml={1} className={classes.boldUnderline}>
            Damages caused by self –repair or modification not authorized by PC
            WORTH.
          </Paragraph>
        </FlexRow>
        <FlexRow>
          <Paragraph ml={3}>{"k)"}</Paragraph>
          <Paragraph ml={1}>
            Printers using refillable inks, injectable inks, or continuous ink
            systems will automatically void the warranty.
          </Paragraph>
        </FlexRow>
        <FlexRow>
          <Paragraph ml={3}>{"l)"}</Paragraph>
          <Paragraph ml={1}>Video cards or GPUs are used for mining.</Paragraph>
        </FlexRow>
        <FlexRow mt={1}>
          <Paragraph>9.</Paragraph>
          <Paragraph ml={1}>
            There will be no on-site service and no lending of backup/services
            units.{" "}
            <Span className={classes.boldUnderline}>
              ALL SHIPPING COSTS RELATED TO WARRANTY CONCERNS SHALL BE AT THE
              ACCOUNT OF THE CUSTOMER.
            </Span>
          </Paragraph>
        </FlexRow>
        <FlexRow mt={1}>
          <Paragraph>10.</Paragraph>
          <Paragraph ml={1}>
            If the replacement for a defective item is no longer available
            (phased-out already), PC WORTH reserves the right to offer an
            alternative brand/ Model to the customer based on the current market
            value of the item or the actual purchase price, whichever is lower.
            In case of upgrades, PC WORTH reserves the right to ask for an
            additional payment from the customer provided the said amount is
            agreeable to the customer. (e.g. P350 upgrade from 250gb to 500gb
            hard disk).
          </Paragraph>
        </FlexRow>
        <FlexRow mt={1}>
          <Paragraph>11.</Paragraph>
          <Paragraph ml={1}>
            In no event or circumstance will PC WORTH or PC WORTH’s supplier be
            liable to the client for any direct, indirect, incidental, special
            or consequential damages arising out of the use of any product or
            documentations like computer hardware, software, accessories,
            upgrades, etc. including any lost profit or lost savings or any
            claim by any party. We will not be held liable for delays on the
            items sent to third party manufacturing either for repair or
            replacement.
          </Paragraph>
        </FlexRow>
        <FlexRow mt={1}>
          <Paragraph>12.</Paragraph>
          <Paragraph ml={1}>
            Any warranty items not claimed within 30 days from date of notice
            will be charged 50 pesos/ day as a storage fee.{" "}
            <Span className={classes.boldUnderline}>
              WARRANTY ITEMS NOT CLAIMED WITHIN 90 DAYS WILL BE SUBJECT TO
              DISPOSAL IN FAVOR TO OUR COMPANY.
            </Span>
          </Paragraph>
        </FlexRow>
        <FlexRow mt={1}>
          <Paragraph>13.</Paragraph>
          <Paragraph ml={1}>
            Prices and stock are subject to change without prior notice.
          </Paragraph>
        </FlexRow>
        <FlexRow mt={1}>
          <Paragraph>14.</Paragraph>
          <Paragraph ml={1}>
            By ordering online, I agree that my data will be used to process my
            order and enhance my experience on pcworth.com.
          </Paragraph>
        </FlexRow>
        <FlexRow mt={1}>
          <Paragraph>15.</Paragraph>
          <Paragraph ml={1} className={classes.boldUnderline}>
            IF THE ITEM/S WAS PURCHASED ONLINE, THE CUSTOMER IS CONSIDERED
            AGREEING WITH THE WARRANTY TERMS AND CONDITION (STATEMENT ABOVE)
            WITHOUT THEIR SIGNATURE.
          </Paragraph>
        </FlexRow>
        <FlexRow mt={1}>
          <Paragraph>16.</Paragraph>
          <Paragraph ml={1}>
            Same day delivery is applicable only for Metro Manila and nearby
            areas of Rizal, Cavite and Bulacan with 3PM cut off time
          </Paragraph>
        </FlexRow>
        <FlexRow mt={1}>
          <Paragraph>17.</Paragraph>
          <Paragraph ml={1}>
            <strong>REFUND POLICY FOR UNAVAILABLE ITEMS</strong>
          </Paragraph>
        </FlexRow>
        <FlexRow mt={1}>
          <Paragraph ml={1}>
            If a product purchased through our website is not available, we
            ensure a prompt and hassle-free refund. The timeframe for the refund
            to be reflected in your account varies based on the payment method
            used:
          </Paragraph>
        </FlexRow>

        <FlexRow mt={1}>
          <Paragraph ml={1}>
            <strong>Debit and Credit Card Transactions - </strong>
          </Paragraph>
          <Paragraph ml={0.5}>Up to 30 days.</Paragraph>
        </FlexRow>

        <FlexRow mt={1}>
          <Paragraph ml={1}>
            <strong>GCash Transactions - </strong>
          </Paragraph>
          <Paragraph ml={0.5}>Within 24 hours.</Paragraph>
        </FlexRow>

        <FlexRow mt={1}>
          <Paragraph ml={1}>
            <strong>GrabPay Transactions - </strong>
          </Paragraph>
          <Paragraph ml={0.5}>Within 24 hours.</Paragraph>
        </FlexRow>

        <FlexRow mt={1}>
          <Paragraph ml={1}>
            <strong>Maya Transactions - </strong>
          </Paragraph>
          <Paragraph ml={0.5}>Within 24 hours.</Paragraph>
        </FlexRow>

        <FlexRow mt={1}>
          <Paragraph ml={1}>
            <strong>BPI Online Banking Transactions - </strong>
          </Paragraph>
          <Paragraph ml={0.5}>Upon request, at least 3 banking days.</Paragraph>
        </FlexRow>

        <FlexRow mt={1}>
          <Paragraph ml={1}>
            <strong>UBP Online Banking Transactions - </strong>
          </Paragraph>
          <Paragraph ml={0.5}>Upon request, at least 3 banking days.</Paragraph>
        </FlexRow>

        <FlexRow mt={1}>
          <Paragraph ml={1}>
            <strong>BillEase Transactions - </strong>
          </Paragraph>
          <Paragraph ml={0.5}>Within 24 hours.</Paragraph>
        </FlexRow>

        <FlexRow mt={1}>
          <Paragraph ml={1}>
            <strong>Over-the-Counter (OTC) Refunds - </strong>
          </Paragraph>
          <Paragraph ml={0.5}>
            Refunds not available for OTC transactions (7-Eleven, M Lhuillier,
            Cebuana).
          </Paragraph>
        </FlexRow>
      </Container>
    </ShopLayout1>
  );
};

export default TermsAndConditions;
